import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Util } from '@leverege/api-attributes'
import { Flex } from '@leverege/ui-elements'

import { Button } from 'react-bootstrap';
import { TransitionGroup } from 'react-transition-group';
import classNames from 'classnames';
import { TextInput, YesNoDialog } from '~/views';
import AttributeTree from '~/reducers/AttributeTree.js';
import { removeAttributeGroup, changeAttributeGroup } from '~/actions/BlueprintActions.js';
import ComponentAttrs from '~/editors/attributes';

import ItemFactory from './ItemFactory.jsx'
import style from './style.css';

class Children extends React.Component {
  constructor( props, context ) {
    super( props, context )
    this.ref = React.createRef()
  }

  componentWillEnter( callback ) {
    const el = this.ref.current
    TweenMax.set( el, { height : 'auto' } );
    // console.log( "animate to ", h );
    TweenMax.from( el, 0.3, { height : 0, opacity : 1, onComplete : callback } );
  }

  componentWillLeave( callback ) {
    const el = this.ref.current
    TweenMax.to( el, 0.3, { height : 0, opacity : 0, onComplete : callback } );
  }

  render() {
    return (
      <div ref={this.ref} className={classNames( style.attributeChildren/* ,this.state.opened?null:style.childrenClosed*/ )}>
        {this.props.children}
      </div>
    )

  }
}

class GroupItem extends React.Component {
  
  static propTypes = {
    parent : PropTypes.object,
    item : PropTypes.object,
    blueprint : PropTypes.object,
    onSelect : PropTypes.func,
    selectedItem : PropTypes.object
  }

  state = {
    open : false,
  };

  constructor( props ) {
    super( props );
    this.state.opened = true;
    this.state.numberToRemove = 0;
    this.state.promptUserForRemove = false;
    this.onSelect = this.onSelect.bind( this );
    this.onNameChange = this.onNameChange.bind( this );
    this.onRemove = this.onRemove.bind( this );
    this.onToggle = this.onToggle.bind( this );
    this.onPromptRemoveYes = this.onPromptRemoveYes.bind( this );
    this.onPromptRemoveNo = this.onPromptRemoveNo.bind( this );
  }

  create( item ) {
    return ItemFactory.createTreeItem( item, { 
      key : item.id,
      parent : this.props.item, 
      item, 
      blueprint : this.props.blueprint,
      onSelect : this.props.onSelect,
      selectedItem : this.props.selectedItem
    } )
  }

  onSelect() {
    if ( this.props.onSelect ) {
      this.props.onSelect( this.props.item );
    }
  }

  onToggle() {
    this.setState( { opened : !this.state.opened } )
  }

  onRemove() {
    const attrs = AttributeTree.getAllAttributes( this.props.item );

    if ( attrs == null || attrs.length == 0 ) {
      this.props.dispatch( removeAttributeGroup( this.props.blueprint, this.props.item ) )
    } else {
      this.setState( { promptUserForRemove : true, numberToRemove : attrs.length } )
    }
  }

  onPromptRemoveYes() {
    this.props.dispatch( removeAttributeGroup( this.props.blueprint, this.props.item ) )
    this.setState( { promptUserForRemove : false } )
  }

  onPromptRemoveNo() {
    this.setState( { promptUserForRemove : false } )
  }

  onNameChange( value, error ) {
    if ( !error ) {
      const { blueprint, item } = this.props
      this.props.dispatch( changeAttributeGroup( blueprint, item, value ) )
    }
  }

  render() {
    const { parent, item, blueprint } = this.props
    const validator = ComponentAttrs.createPathValidator( parent, blueprint && blueprint.attributes, item );
    const acceptKey = ComponentAttrs.EventKeyValidator;

    const children = [];
    if ( item.items ) { 
      for ( let n = 0; n < item.items.length; n++ ) {
        const c = this.create( item.items[n] );
        if ( c ) {
          children.push( c );
        }
      }
    }
    const desc = item.desc == null ? null :                   
    <div className={style.attributeSubtitle}>{item.desc}</div>

    const selected = this.props.item == this.props.selectedItem;
    const cn = classNames( style.attributeArea, selected ? style.selected : null );
    const buttons = this.renderButtons( selected );

    const openIconRot = this.state.opened ? 'fa-rotate-90' : '';

    let collectionInfo = null
    if ( item.name.endsWith( '@' ) ) {
      collectionInfo = 'collection'
    } else if ( item.name.endsWith( '*' ) ) {
      collectionInfo = 'array'
    }

    return (
      <div className={style.attributeGroup}>
        <div direction="row" align="flex-start" className={cn} onClick={this.onSelect}>
          <div className={style.attributeNames}>
            <Button bsSize="large"
              bsStyle="link"
              className={classNames( style.groupOpenButton, style.attributeButton )} 
              onClick={this.onToggle}> 
              <i className={`fa fa-chevron-right ${openIconRot}`} />
            </Button>
            <div className={style.attribute}>
              <TextInput className={style.attributeTitle} 
                onChange={this.onNameChange}
                validator={Util.isPathValid}
                acceptKey={acceptKey}
                value={item.name} />
              <div className={style.collectionInfo}>
                {collectionInfo}
              </div>
            </div>
            {desc}
          </div>
          {buttons}
        </div>
        <TransitionGroup>
          { this.state.opened && <Children>{children}</Children>}
        </TransitionGroup>

        <YesNoDialog show={this.state.promptUserForRemove} 
          title="Remove Group and Attributes"
          message={this.state.numberToRemove > 1 ? 
            (
              <div>
                Are you sure you want to delete the group and its
                {' '}
                <b>
                  {this.state.numberToRemove}
                  {' '}
                  attributes
                </b>
                ?
              </div>
            ) :
            (
              <div>
                Are you sure you want to delete the group and its
                {' '}
                <b>one attribute</b>
                ?
              </div>
            )}
          onYes={this.onPromptRemoveYes}
          onNo={this.onPromptRemoveNo} />
      </div>
    )
  }

  renderButtons( selected ) {

    return (
      <div className={classNames( style.attributeButtons, selected && style.selected )}>
        <Button bsStyle="link" bsSize="large" className={classNames( style.attributeButton, style.remove )} onClick={this.onRemove}> 
          <i className="fa fa-fw fa-trash" />
        </Button>
      </div>
    );
  }

}

export default connect( state => ( { } ) )( GroupItem )
